/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var DepLocationDashboardView = require('../views/DepLocationDashboardView');
var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');
var GetEntityDocMgmtDetails = require('../../common/services/GetEntityDocMgmtDetails');
var GetLocation = require('../services/GetLocation');

module.exports = function(entityId, locationId) {
  NProgress.start();
  NProgress.set(0.6);
  $.when(GetLocation(locationId), GetEntityIdentifiers(entityId), GetEntityDocMgmtDetails(entityId))
    .done(function(location, entityIdentifiers, docMgmt) {
      NavUtils.navigate('dep/entity/' + entityId + '/location/' + locationId);
      Scaffold.content.show(
        new DepLocationDashboardView({
          viewMode: 'int',
          model: new Backbone.Model({
            entityId: entityId,
            entityIdentifiers: entityIdentifiers,
            locationId: locationId,
            location: location,
            locationsCSFolderId: docMgmt.locationsCSFolderId
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
